import FurnitureLightingFrame from './components/FurnitureLightingFrame'
import FurnitureLightingForm from './components/FurnitureLightingForm'
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: '/prize-designs-for-modern-furniture-lighting',
        name: 'furniture-lighting-frame',
        meta: {
            auth: true,
            basePath: true,
            award: 'lighting',
            awardName: 'Prize Designs for Modern Furniture+Lighting Award'
        },
        component: FurnitureLightingFrame,
        children: [
            {
                path: '',
                component: FurnitureLightingForm,
                name: 'furniture-lighting-form'
            },
            ...UserAccountRoutes
        ]
    },

    /*/future-house-awards*/
]
